import { Question } from "./question.model";
export class Questions {
    questions: Question[];
}
